<template>
    <div class="md step-essay">
        <ul>
            <li
                v-for="(item, index) in node "
                :key="index"
                :class="[item.status? 'is-'+ item.status: '']"
            >
                <div class="div">
                    <div class="caption">
                        <a>{{ item.caption }}</a>
                    </div>
                    <div class="label">{{ item.text }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

    export default {
        props: {
            node: {
                type: Array,
                require: false,
                default: function(){
                    return []
                }
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.step-essay {
        $circle-size: 20px;
        $border-height: 2px;
        $padding: $interval-l;
        $opacity: $opacity-m;

        ul {
            @extend %reset;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            padding: 0 $interval-xxl * 3;

            @include media('center') {
                padding: 0 $interval-xxl;
            }

            @include media('pad') {
                padding: 0;
            }

            @include media('phone') {
                display: block;
                padding: 0;
            }
        }

        li {
            position: relative;
            width: 14.28%;

            &:first-child:last-child {
                width: 100%;
            }

            &:first-child:nth-last-child(2),  &:first-child:nth-last-child(2) ~ li {
                width: 50%;
            }

            &:first-child:nth-last-child(3),  &:first-child:nth-last-child(3) ~ li {
                width: 33.3%;
            }

            &:first-child:nth-last-child(4),  &:first-child:nth-last-child(4) ~ li {
                width: 25%;
            }

            &:first-child:nth-last-child(5),  &:first-child:nth-last-child(5) ~ li {
                width: 20%;
            }

            @include media('phone') {
                width: auto !important; 
            }

            &::before, &::after {
                content: $content;
                position: absolute;
                top: $padding + $circle-size / 2 - $border-height / 2;
                height: $border-height;
                width: 100%;
                background-color: $minor-color;

                @include media('phone') {
                    top: auto;
                    left: $circle-size / 2;
                    height: 100%;
                    width: $border-height;
                }
            }

            &::before {
                right: 50%;
                margin-left: -1 * $border-height / 2;

                @include media('phone') {
                    right: auto;
                    bottom: 50%;
                }
            }

            &::after {
                left: 50%;
                margin-left: -1 * $border-height / 2;

                @include media('phone') {
                    content: none;
                }
            }

            &:first-child {

                &::before {
                    content: none;
                }
            }

            &:last-child {

                &::after {
                    content: none;
                }
            }

            &.is-active {

                &::before, &::after {
                    background-color: $major-color;
                }
                
                .div {
                
                    &::before {
                        background-color: $major-color;
                    }
                }

                .caption {
                    opacity: 1;
                }
            
                .label {
                    opacity: 1;
                }
            
                .func {
                    opacity: 1;
                }
            }
        }

        .div {
            text-align: center;
            padding-top: $padding;

            @include media('phone') {
                text-align: left;
                padding: $interval-m 0 $interval-m $circle-size + $padding;
            }

            &::before {
                content: $content;
                text-align: center;
                display: inline-block;
                width: $circle-size;
                height: $circle-size;
                border-radius: $circle-size;
                background-color: $minor-color;
                transition: $transition;
                position: relative;
                z-index: 1;

                @include media('phone') {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    margin-top:  -1 * ($circle-size / 2) - $border-height;
                }
            }
        }

        .caption {
            margin-top: $interval-m;
            opacity: $opacity;

            @include media('phone') {
                margin-top: 0;
                display: inline-block;
                margin-right: $interval-m;
                vertical-align: middle;
            }

            a {
                font-size: $font-size-xl;
            }
        }

        .lable {
            margin-top: $interval-s;
            opacity: $opacity;

            @include media('phone') {
                margin-top: 0;
                display: inline-block;
                margin-right: $interval-m;
                vertical-align: middle;
            }
        }
    }
</style>
